import React from "react";
import * as SCConst from "./SCConst";
import TCheckBoxLabel from "../../../Library/Labels/TCheckBoxLabel";
import { SCService } from "../../../API/server_calls";

/* Returns true if changing variable 1 (varName1) has an affect on variable 2 (varName2). */
export function affectsVar(varName1, varName2) {
    let result = false;

    if (varName1 === SCConst.provincesIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.geoTypesIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.PEPFAR_CatsIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.VMMC_CatsIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.DREAMS_CatsIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.USG_AgenciesIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.impPartnersIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.servDelivModesIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.ownershipTypesIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    } else if (varName1 === SCConst.SNUsIncluded) {
        if (varName2 === SCConst.sitesIncluded) {
            result = true;
        }
    }

    return result;
}

export function isConfigField(varName) {
    let result = false;

    if (
        varName === SCConst.level ||
        varName === SCConst.timeInterval ||
        varName === SCConst.month ||
        varName === SCConst.quarter ||
        varName === SCConst.half ||
        varName === SCConst.year ||
        varName === SCConst.timeIntervalValsAggr ||
        varName === SCConst.provincesIncluded ||
        varName === SCConst.geoTypesIncluded ||
        varName === SCConst.PEPFAR_CatsIncluded ||
        varName === SCConst.VMMC_CatsIncluded ||
        varName === SCConst.DREAMS_CatsIncluded ||
        varName === SCConst.USG_AgenciesIncluded ||
        varName === SCConst.impPartnersIncluded ||
        varName === SCConst.servDelivModesIncluded ||
        varName === SCConst.ownershipTypesIncluded ||
        varName === SCConst.SNUsIncluded ||
        varName === SCConst.sitesIncluded ||
        varName === SCConst.sitesDisplayed ||
        varName === SCConst.xAxisVar ||
        varName === SCConst.indsIncluded ||
        varName === SCConst.provincesStr ||
        varName === SCConst.geoTypesStr ||
        varName === SCConst.PEPFAR_CatsStr ||
        varName === SCConst.VMMC_CatsStr ||
        varName === SCConst.DREAMS_CatsStr ||
        varName === SCConst.USG_AgenciesStr ||
        varName === SCConst.impPartnersStr ||
        varName === SCConst.servDelivModesStr ||
        varName === SCConst.ownershipTypesStr ||
        varName === SCConst.SNUsStr ||
        varName === SCConst.sitesStr
    ) {
        result = true;
    }

    return result;
}

export function getCatDivStyle() {
    return {
        //float: 'left',
        verticalAlign: "top",
        //height: '125px',
        padding: "20px",
        width: "300px",
        display: "inline-block",
    };
}

export function SC_CreateCheckBox(
    varName,
    numDimensions,
    currID,
    currID2,
    caption,
    key,
    config,
    onCheckboxChange,
    onLabelClick,
    labelStyle
) {
    if (typeof key === "undefined") {
        if (numDimensions === 1) {
            key = varName + currID;
        } else if (numDimensions === 2) {
            key = varName + currID * currID2;
        } else {
            key = varName;
        }
    }

    let value = "";
    let info = [];
    if (numDimensions === 1) {
        if (isConfigField(varName)) {
            value = config[varName][currID];
        }

        info.push(varName);
        info.push(currID);
    } else if (numDimensions === 2) {
        value = config[varName][currID][currID2];

        info.push(varName);
        info.push(currID);
        info.push(currID2);
    } else {
        value = config[varName];
        info.push(varName);
    }

    let style = {
        label: {
            fontSize: 13,
        },
    };
    if (typeof labelStyle !== "undefined") {
        style.label = {
            fontSize: 13,
            ...labelStyle,
        };
    }

    return (
        <TCheckBoxLabel
            caption={caption}
            value={value}
            info={info}
            onClick={onCheckboxChange}
            key={key}
            style={{ height: "auto", margin: "margin: 0px 0px 0px 0px" }}
            labelStyle={style.label}
            onLabelClick={onLabelClick}
        />
    );
}

/* Generic function for creating checkboxes. If your checkboxes need new parameters, make a different function
   to avoid giving this a massive parameter list, since most checkboxes won't need all those parameters. */
export function SC_CreateCheckboxes(
    configOptName,
    configOptStrName,
    ignoreAll,
    sectorID,
    config,
    displayOL,
    onCheckboxChange
) {
    let strArray;
    const checkBoxArray = [];

    if (isConfigField(configOptName)) {
        const start = ignoreAll ? 1 : 0;
        strArray = config[configOptStrName];
        for (let i = start; i < strArray.length; i++) {
            checkBoxArray.push(SC_CreateCheckBox(configOptName, 1, i, 0, strArray[i], i, config, onCheckboxChange));
        }
    }

    return checkBoxArray;
}

export function SC_SaveOptions(config, configExtra, successFn) {
    const setConfigOptObjError = () => {
        alert("An error has occurred while sending configuration options to the server.");
    };

    const getConfigOptObjError = () => {
        alert("An error has occurred while getting configuration options from the server.");
    };

    /* 1. Give the configuration options back to the server so it can figure out which sites to display.
       2. Grab the configuration options back from the server to get the updated list of sites to display.
       3. Update the sites checkboxes.

       AppSideBarCustom's onConfigChange is linked to App.js's onConfigChange in App.js in renderApp. App.js's
       onConfigChange sets the state of config, so passing config here will set it in App.js. */
    SCService.setConfigOptObj(
        config,
        () => {
            SCService.getConfigOptObj((newConfig) => {
                successFn(newConfig, configExtra);
            }, setConfigOptObjError);
        },
        getConfigOptObjError
    );
}

export function SC_onRadioChange(value, info, config, configExtra, successFn) {
    let varName = info[SCConst.varName];
    let idx = info[SCConst.currID1];

    if (isConfigField(varName)) {
        config[varName] = idx;
    }

    successFn(config, configExtra);
}

/* Split an array 'a' into 'n' arrays */
export function chunkify(a, n, balanced) {
    if (n < 2) return [a];

    let len = a.length,
        out = [],
        i = 0,
        size;

    if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
            out.push(a.slice(i, (i += size)));
        }
    } else if (balanced) {
        while (i < len) {
            size = Math.ceil((len - i) / n--);
            out.push(a.slice(i, (i += size)));
        }
    } else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0) size--;
        while (i < size * n) {
            out.push(a.slice(i, (i += size)));
        }
        out.push(a.slice(size * n));
    }

    return out;
}

export function getFinalPossibleYear() {
    const d = new Date();
    return d.getFullYear();
}

export function getFinalPossibleMonth(year) {
    const d = new Date();
    const currentYear = d.getFullYear();

    if (year < currentYear) {
        return 12;
    } else {
        return d.getMonth() + 1;
    }
}

export function getMonthName(month) {
    let monthName = "";

    switch (month) {
        case 0:
            monthName = "January";
            break;
        case 1:
            monthName = "February";
            break;
        case 2:
            monthName = "March";
            break;
        case 3:
            monthName = "April";
            break;
        case 4:
            monthName = "May";
            break;
        case 5:
            monthName = "June";
            break;
        case 6:
            monthName = "July";
            break;
        case 7:
            monthName = "August";
            break;
        case 8:
            monthName = "September";
            break;
        case 9:
            monthName = "October";
            break;
        case 10:
            monthName = "November";
            break;
        case 11:
            monthName = "December";
            break;
        default:
            monthName = "";
    }

    return monthName;
}

export function formatTimeAmPm(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const amPm = hours >= 12 ? "pm" : "am";

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;

    const strTime = hours + ":" + minutes + " " + amPm;

    return strTime;
}

export function getStdResultCurrID(mstIDsObj, stdResMstID) {
    const stdResultMstIDs = mstIDsObj.stdResultMstIDs;

    let currID = 1;
    let foundCurrID = false;
    while (currID <= stdResultMstIDs.length && !foundCurrID) {
        if (stdResultMstIDs[currID] === stdResMstID) {
            foundCurrID = true;
            currID--;
        }
        currID++;
    }
    if (foundCurrID) {
        return currID;
    } else {
        return 0;
    }
}

export function showStdResult(mstIDsObj, stdResCurrID) {
    const stdResultMstIDs = mstIDsObj.stdResultMstIDs;
    const stdResMstID = stdResultMstIDs[stdResCurrID];

    let show = true;

    // if ((stdResMstID === SCConst.demandCreationResMstID) ||
    //     (stdResMstID === SCConst.overallPerformResMstID)) {
    //         show = false;
    // }
    if (stdResMstID !== SCConst.addStaffNeededOptOpResMstID) {
        show = false;
    }

    return show;
}

export function showIndicator(mstIDsObj, indID) {
    const indMstIDs = mstIDsObj[SCConst.indMstIDs];
    const indMstID = indMstIDs[indID];

    let show = true;

    if (
        indMstID === SCConst.anyAdvEventsRateIndCMstID ||
        indMstID === SCConst.percReachedByMobilIndMstID ||
        indMstID === SCConst.percVMMC_PerReachMobilIndCMstID ||
        indMstID === SCConst.VMMC_DoneIndMstID ||
        indMstID === SCConst.VMMC_DoneOverTimeResIndCMstID ||
        indMstID === SCConst.VMMC_DoneSimpleAGIndCMstID ||
        indMstID === SCConst.dailyProdIdxIndCMstID ||
        indMstID === SCConst.optNumVMMC_DailyIndCMstID ||
        indMstID === SCConst.dailyVMMC_DoneIndCMstID ||
        indMstID === SCConst.optUtilizationRateIndCMstID ||
        indMstID === SCConst.currUtilizationRateIndCMstID ||
        indMstID === SCConst.HIVTestDoneResIndCMstID ||
        indMstID === SCConst.numSTI_TreatedIndCMstID ||
        indMstID === SCConst.addProvidersNeededIndCMstID ||
        indMstID === SCConst.addAssistantsNeededIndCMstID ||
        indMstID === SCConst.addNursesNeededIndCMstID ||
        indMstID === SCConst.addMobilisersNeededIndCMstID ||
        indMstID === SCConst.addCounsellorsNeededIndCMstID ||
        indMstID === SCConst.infoSourcesIndMstID
    ) {
        show = false;
    }

    return show;
}

export function getMonthYearComboBoxIdx(month, year) {
    let idx = 0;

    let y = SCConst.firstPossibleYear;
    const finalPossibleYear = getFinalPossibleYear();
    let m;
    let stop = false;

    while (y <= finalPossibleYear && !stop) {
        m = 1;

        while (m <= 12 && !stop) {
            if (!(y === year && m === month)) {
                idx++;
            } else {
                stop = true;
            }

            m++;
        }

        y++;
    }

    return idx;
}

export function getInputValue(value) {
    if (value === SCConst.noData) {
        return "";
    } else {
        return value;
    }
}

export function usingLocalHost() {
    const urlString = window.API_URL;

    if (urlString.includes("localhost")) {
        return true;
    } else {
        return false;
    }
}
